import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
  'https://hdeuxkoofkdawswvqxny.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhkZXV4a29vZmtkYXdzd3ZxeG55Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ3MDgzODAsImV4cCI6MjA5MDI4NDM4MH0.bTRQGfbnzJJLPfTXsGj6aPBcH7P3LVoX4jBT5jnlSRk'
)
